import React, { memo, useEffect, useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import '../LockScreen/index.scss';
import { onClickHandler } from '../../utils/onclick';
import { useNumpad } from '../../hooks/numpad';
import { useRPC } from '../../hooks/rpc';
import { setPasswordAction } from '../../store/control/actions';
import { useDispatch, useSelector } from 'react-redux';
import { useMessage } from "../../hooks/message";
import { useLocalization } from "../../hooks/localization";

export const PinLoginScreen = memo(function PinLoginScreen() {
    const [isAborted] = useState(false);
    const [renderNumpad, password, setPassword] = useNumpad(isAborted);
    const [rpc] = useRPC();
    const passStatus = useSelector(state => state.control.passwordStatus);
    const defaultAlarmState = useSelector(state => state.control.alarmState.default);
    const alarmSettingUp = useSelector(state => state.ui.alarmSettingUp);
    const history = useHistory();
    const dispatch = useDispatch();
    const { failure } = useMessage();
    const { t } = useLocalization();

    useEffect(() => {
        const alarmRinging = defaultAlarmState?.ringing || defaultAlarmState?.will_ring || defaultAlarmState?.level === 3;
        if (alarmRinging || alarmSettingUp) {
            history.push('/alarm');
            return;
        }
        if (passStatus === true) {
            dispatch(setPasswordAction(null));
            history.push('/');
        }
    }, [history, passStatus, dispatch, defaultAlarmState, alarmSettingUp]);

    const openPinLogin = useCallback(() => {
        if (!password || password.trim() === "") {
            failure(t("pls_enter_password"));
            rpc.frontendErrorLog("pls_enter_password"); 
            return;
        }

        rpc.authenticateWithPinCode(password)
            .then(() => {
                dispatch(setPasswordAction(true));
            })
            .catch((error) => {
                setPassword("");
                if (error?.response?.data?.message) {
                    failure(error.response.data.message);
                    rpc.frontendErrorLog(error.response.data.message)
                } else if (error?.message) {
                    failure(error.message);
                    rpc.frontendErrorLog(error.message)
                } else {
                    failure(t("WRONG_PASSWORD"));
                    rpc.frontendErrorLog(error)
                }

                dispatch(setPasswordAction(false));
            });
    }, [password, rpc, setPassword, failure, t, dispatch]);

    return (
        <div className='lock-screen-container'>
            <div className="lock-screen-wrapper">
                {renderNumpad()}
                <div className="lock-screen-button-container">
                    <button className='lock-screen-button' {...onClickHandler(openPinLogin)}>
                        {t('login')}
                    </button>
                    <button
                        className='lock-screen-button'
                        onClick={() => history.push('/settings')}
                    >
                        {t('normal_login')}
                    </button>
                </div>
            </div>
        </div>
    );
});
